// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activation-container {
  width: 50%;
  min-width: 30rem;
  margin: auto;
  margin-top: 5rem;
  background-color: #fff;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  padding: 3rem;
}

.activation-container h5 {
  margin: 1rem;
  font-weight: bold;
  font-size: 2.4rem;
}

.activation-container__form input[type="text"],
.activation-container__form input[type="password"] {
  width: 50%;
}

.activation-container__form textarea {
  width: 90%;
  height: 20rem;
}

.activation-container__form label {
  display: inline-block;
  width: 10rem;
  text-align: left;
  margin-right: 4rem;
}

.activation-container__form-item {
  display: flex;
  justify-content: center;
  align-items: center;
}

.activation-container__form-item-license {
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

input[type="password"]::-ms-reveal,
input[type="password"]::-ms-clear {
  display: none;
}

button[type="submit"] {
  margin-top: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/license/license-activation/LicenseActivation.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB;sEACoE;EACpE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".activation-container {\r\n  width: 50%;\r\n  min-width: 30rem;\r\n  margin: auto;\r\n  margin-top: 5rem;\r\n  background-color: #fff;\r\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),\r\n    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);\r\n  border-radius: 2px;\r\n  padding: 3rem;\r\n}\r\n\r\n.activation-container h5 {\r\n  margin: 1rem;\r\n  font-weight: bold;\r\n  font-size: 2.4rem;\r\n}\r\n\r\n.activation-container__form input[type=\"text\"],\r\n.activation-container__form input[type=\"password\"] {\r\n  width: 50%;\r\n}\r\n\r\n.activation-container__form textarea {\r\n  width: 90%;\r\n  height: 20rem;\r\n}\r\n\r\n.activation-container__form label {\r\n  display: inline-block;\r\n  width: 10rem;\r\n  text-align: left;\r\n  margin-right: 4rem;\r\n}\r\n\r\n.activation-container__form-item {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.activation-container__form-item-license {\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\ninput[type=\"password\"]::-ms-reveal,\r\ninput[type=\"password\"]::-ms-clear {\r\n  display: none;\r\n}\r\n\r\nbutton[type=\"submit\"] {\r\n  margin-top: 2rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
